import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingTemplateComponent } from '@freelancer/ui/loading-template';

@Component({
  selector: 'fl-challenge-card-compact-loading',
  standalone: true,
  imports: [LoadingTemplateComponent],
  template: ` <fl-loading-template></fl-loading-template> `,
  styleUrls: ['./challenge-card-compact-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChallengeCardCompactLoadingComponent {}
